import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-form';
import 'jquery-validation';
import '../../assets/scripts/jquery-validation.init';
import * as helper from '../global/helper';
import swal from 'sweetalert2';
import { setAuthState, setTempState } from '../../assets/scripts/login-util';
import { checkVersion } from '../../assets/scripts/versionComparer';
import { deviceDetect } from "react-device-detect";
import { loginAPI, googleLoginAPI } from  "../api/agentAPI";
import { hasFeature } from "../api/billingAPI";
import { googleLogin } from './loginHelper';
import { EmailField, PasswordField, OrDivider, ArrowIcon } from './authFields';


const SignIn = (props) => {
  const googleErrorLogs = ['auth/popup-closed-by-user', 'auth/popup-blocked', 'auth/cancelled-popup-request'];
  const history                           = useHistory();
  const [loginData,     setLoginData]     = useState({ isremember: true });
  const [loading,  setLoading]            = useState(false);
  
  useEffect(() => {
    document.title = "Sign In | Insurebox.co"
    document.getElementsByTagName('meta')["description"].content = "Login to insurebox insurance agency management software dashboard to manage the data."
  })

  const loginDataHandler = (key, value)=>{
    setLoginData((d)=> { return {...d, [key] : value} });
  }

  const submitHandler = async (e) => {
    e.preventDefault();

    const btn = $('#kt_login_signin_submit');
    const form = $('#kt_login_signin');

    form.validate({
      rules: {
        email: {
          required: true,
          email: true,
        },
        password: {
          required: true,
        },
      },
    });

    if (!form.valid()) return;

    helper.StartProcessing(btn);
    try {
      const deviceData = deviceDetect();
      loginData.device = await helper.getDeviceDetails(deviceData);

      // Call Login API
      const params = await loginAPI(loginData);
      if(params.emailVerification){
        const stateObj = {
          Email     : loginData.email,
          isRemember: loginData.isremember,
          device    : loginData.device,
          ...params
        }

        history.push({ pathname: '/verify/email', state: stateObj });
        return;
      }
      
      if(params.user){
        //Set Auth State
        setAuthState(params, loginData.isremember);

        //Call CustomFunction to Register CookieChange Event ->

        window.cookieChangeHandler();

        // Task 6: sourced from the entitlement bundle (TEAM_ACCESS) instead
        // of the legacy TempSubscription.Team flag - a purely-UX precheck,
        // now possible only once authenticated (the flag used to come
        // from an unauthenticated TempSubscription lookup by companyId).
        // The server's own auth gate enforces this on every request
        // regardless; this only avoids logging a blocked member in and
        // immediately kicking them back out on their next click.
        if (params.user.categoryId != 1) {
          const teamAccess = await hasFeature('TEAM_ACCESS');
          if (!teamAccess) {
            setAuthState();
            swal.fire({
              icon                  : 'error',
              titleText             : 'Error!',
              text                  : "Minimum 3 License Required",
              buttonsStyling        : false,
              confirmButtonClass    : 'btn btn-brand',
            });
            helper.StopProcessing(btn);
            return;
          }
        }

        checkVersion(params.FE_VERSION);
        props.onLogin();
      }else{
        // Create a Session Cookie 
        setTempState(params); 
        props.onLogin('created');
      }

    } catch (err) {
      helper.StopProcessing(btn);
      if(err.message == 'Invalid password'){
        swal.fire({ 
          icon              : "warning",
          titleText         : "Create a password",
          text              : "Since you've signed up with Google, you don't have a password.",
          confirmButtonText: 'Create Password',
          showCancelButton:true,
          confirmButtonClass: "btn btn-brand mt-0",
        }).then((result)=>{
          if (result.isConfirmed) {
            history.push('/forgot-password', {createPassword : true});
          } 
        })
      }else{
        swal.fire({
          icon              : "error",
          titleText         : "Error!",
          text              : err.message,
          buttonsStyling    : false,
          confirmButtonClass: "btn btn-brand",
        })
      }

      return; 
    }
  };

  const onGoogleLogin = async() => {
    const deviceData = deviceDetect();
    const btn = $('#kt_login_signin_google');
    try {
      setLoading(true)
      helper.StartProcessing(btn)
      const IdToken = await googleLogin();
      if(IdToken){
        const device = await helper.getDeviceDetails(deviceData);
        const params = await googleLoginAPI({
          googleTokenId : IdToken,
          device,
          isremember : loginData.isremember,
        });

        if(params.user){
          //Set Auth State
          setAuthState(params, loginData.isremember);
          checkVersion(params.FE_VERSION);
          props.onLogin();
        }else{
          // Create a Session Cookie for temp user
          setTempState(params); 
          props.onLogin('created');
        }
      }
    } catch (err) {
      setLoading(false)
      helper.StopProcessing(btn); 
      if(googleErrorLogs.includes(err.message) ) return;
      let titleText = err.message == 'User does not exist'?'Please SignUp' : 'Error!';
      swal.fire({
        icon              : "error",
        titleText         : titleText,
        text              : err.message,
        buttonsStyling    : false,
        confirmButtonClass: "btn btn-brand",
      });
    } 
  }

  return (
    <div className="kt-login__signin">
      <div className="ib-auth-head">
        <h3 className="ib-auth-title">Welcome Back</h3>
        <p className="ib-auth-subtitle">Sign in to access your InsureBox account</p>
      </div>
      <form className="kt-form ib-auth-form" id="kt_login_signin" onSubmit={submitHandler} noValidate>
        <EmailField
          id="ib-signin-email"
          value={loginData.email || ''}
          onChange={({ target }) => loginDataHandler('email', target.value)}
        />
        <PasswordField
          id="ib-signin-password"
          name="password"
          label="Password"
          placeholder="Enter your password"
          value={loginData.password || ''}
          onChange={({ target }) => loginDataHandler('password', target.value)}
        />

        <div className="ib-auth-row">
          <label className="ib-checkbox">
            <input
              type="checkbox"
              name="rememberme"
              checked={!!loginData.isremember}
              onChange={() => loginDataHandler("isremember", !loginData.isremember)}
            />
            <span className="ib-checkbox__box" aria-hidden="true" />
            Remember me
          </label>
          <Link to="/forgot-password" id="kt_login_forgot" className="ib-auth-link">
            Forgot password?
          </Link>
        </div>

        <button
          type="submit"
          disabled={loading}
          id="kt_login_signin_submit"
          className="btn ib-auth-btn ib-auth-btn--primary"
        >
          Sign In <ArrowIcon />
        </button>

        <OrDivider />

        <button
          type="button"
          onClick={onGoogleLogin}
          disabled={loading}
          id="kt_login_signin_google"
          className="btn ib-auth-btn ib-auth-btn--google"
        >
          {helper.googleBtn}<span>Sign in with Google</span>
        </button>

        <p className="ib-auth-switch">
          Don't have an account yet?{' '}
          <Link to="/signup" id="kt_login_signup" className="ib-auth-link">Sign Up</Link>
        </p>
      </form>
    </div>
  );
};

export default SignIn;
